// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"UserMenu_avatarWrapper__4aKLc"};